import { z } from "zod"

export const formSchema = z.object({
  bankAccountId: z.string().min(1, { message: "Bank account is required" }),
})
